import { SeeMoreCard, WhiteBox } from "@foodpilot/foods";
import { Box, Stack, SxProps, Theme, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { QuestionnaireOverview } from "src/api/client-api/company/overview/useOrganizationOverview";
import { OverviewHeader } from "./OverviewHeader";
import { BodyOverview } from "./BodyOverview";

type DiagnosticOverviewProps = {
    ssqs: QuestionnaireOverview[];
};
export const DiagnosticOverview = (props: DiagnosticOverviewProps) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const { ssqs: _ssqs } = props;

    const ssqs = [..._ssqs];

    const previewItems = ssqs.slice(0, 3);
    const seeMoreItems = ssqs.slice(3, ssqs.length);

    const questionnaireGrid: SxProps<Theme> = {
        display: "grid",
        gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)", lg: "repeat(3, 1fr)" },
        columnGap: theme.spacing(1),
        rowGap: theme.spacing(3),
    };

    return (
        <WhiteBox>
            <SeeMoreCard
                seeMoreText={t("components.see_more.questionnaire", "See more questionnaires")}
                seeLessText={t("components.see_less.questionnaire", "See less questionnaires")}
                hidden={
                    seeMoreItems.length > 0 ?
                        <Box sx={[questionnaireGrid, { marginTop: theme.spacing(2) }]}>
                            {seeMoreItems.map((item) => {
                                return <BodyOverview key={item.id} overview={item} />;
                            })}
                        </Box>
                    :   undefined
                }
                defaultVisible={false}
            >
                <Stack gap={theme.spacing(2)}>
                    <OverviewHeader ssqsCount={ssqs.length} />
                    <Box sx={questionnaireGrid}>
                        {previewItems.map((item) => {
                            return <BodyOverview key={item.id} overview={item} />;
                        })}
                    </Box>
                </Stack>
            </SeeMoreCard>
        </WhiteBox>
    );
};
